import React, { useState, useEffect } from "react";
import { withTranslation } from "react-i18next";
import { useSelector } from "react-redux";

import { UncontrolledTooltip } from "reactstrap";
import { isArray } from "../../../../../Libs/CustomMethods/customMethods";

import FlashMsg from "../../FlashMessage/FlashMsg.js";

import "./FlashMsgList.scss";

const FlashMsgList = ({
  t,
  searchTextFlash,
  setSearchTextFlash,
  setDefaultFlashMsg,
  setFlashMsg,
  refIndex,
  setRefIndex,
}) => {
  const { mainTheme } = useSelector((state) => state.Layout);
  const { dataFlashMsg } = useSelector((state) => state.FlashMsgs);

  const [flashMsgRefs, setFlashMsgRefs] = useState([]);
  const [flashMsgList, setFlashMsgList] = useState([]);
  const [regexExp, setRegexExp] = useState(null);

  const [isFlashEditCreate, setIsFlashEditCreate] = useState(false);
  const [isFlashDelete, setIsFlashDelete] = useState(false);
  const [objFlashMsg, setObjFlashMessage] = useState({});

  const toggleFlashEditCreate = () => setIsFlashEditCreate((prev) => !prev);
  const toggleFlashDelete = () => setIsFlashDelete((prev) => !prev);

  const resetAndClose = () => {
    setSearchTextFlash(null);
    setRegexExp(null);
    flashMsgRefs[0]?.current?.parentElement?.focus();
  };

  const onSelectMsg = (obj) => {
    resetAndClose();
    setFlashMsg(obj?.message);
  };

  const handleEnter = (element) => {
    onSelectMsg(element);
  };

  const handleArrowUp = () => {
    if (refIndex > 0) {
      setRefIndex((prev) => prev - 1);
    }
  };

  const handleArrowDown = () => {
    if (refIndex < flashMsgList.length - 1) {
      setRefIndex((prev) => prev + 1);
    }
  };

  const handleEscape = () => {
    resetAndClose();
  };

  const displayMsgList = (value, exp) => {
    let stringArray = value.split(exp);
    let pos = stringArray.findIndex((e) => e.match(exp));
    return (
      <div className="d-flex flash-messages-search">
        {stringArray.map((e, key) =>
          pos && key === pos ? (
            <div key={key} className="font-weight-bold text-success">
              {e}
            </div>
          ) : (
            <div key={key}>{e}</div>
          )
        )}
      </div>
    );
  };

  useEffect(() => {
    if (typeof refIndex === "number") {
      flashMsgRefs[0]?.current?.parentElement?.classList.remove("active");
      flashMsgRefs[refIndex]?.current?.parentElement?.focus();
    }
  }, [refIndex, flashMsgRefs]);

  useEffect(() => {
    if (flashMsgList?.length > 0) {
      setDefaultFlashMsg(flashMsgList[0]?.message);
      flashMsgRefs[0]?.current?.parentElement?.classList.add("active");
    } else {
      setDefaultFlashMsg(null);
      flashMsgRefs[0]?.current?.parentElement?.classList.remove("active");
      setSearchTextFlash(null);
    }
  }, [flashMsgList, flashMsgRefs, setDefaultFlashMsg, setSearchTextFlash]);

  useEffect(() => {
    let exp = null;
    let msgList = dataFlashMsg?.responseFlash;
    if (searchTextFlash && typeof searchTextFlash !== "boolean") {
      let noSlash = searchTextFlash.substr(2, searchTextFlash.length);
      let noSpecialChars = noSlash?.replace(/[|\\{}()[\]^$+*?.]/g, "\\$&");
      exp = noSpecialChars && new RegExp(`(${noSpecialChars})`, "ig");
      msgList = dataFlashMsg?.responseFlash.filter((e) =>
        e.short_name.match(exp)
      );
    }
    setRegexExp(exp);
    setFlashMsgList(msgList);
  }, [searchTextFlash, dataFlashMsg?.responseFlash]);

  useEffect(() => {
    if (isArray(dataFlashMsg?.responseFlash)) {
      setFlashMsgRefs((refs) =>
        Array(dataFlashMsg.responseFlash.length)
          .fill()
          .map((_, i) => refs[i] || React.createRef())
      );
    }
  }, [dataFlashMsg]);

  return (
    <>
      <div
        onClick={() => {
          setObjFlashMessage({});
          toggleFlashEditCreate();
        }}
        className="text-success pointer"
        id="create-flash-message"
      >
        {t("Create")}
        <UncontrolledTooltip target="create-flash-message">
          {t("New Flash Message")}
        </UncontrolledTooltip>
      </div>
      <hr className="dropdown-divider"></hr>
      <div className="flash-messages-list">
        {flashMsgList?.length > 0 &&
          flashMsgList?.map((element, key) => (
            <a
              key={key}
              href="/#"
              className={`d-flex justify-content-between px-2 pointer flashMessageItem ${mainTheme}`}
              onClick={(e) => {
                e.preventDefault();
              }}
              onKeyDown={(e) => {
                switch (e.key) {
                  case "Enter":
                    e.preventDefault();
                    handleEnter(element);
                    break;
                  case "ArrowUp":
                    handleArrowUp();
                    break;
                  case "ArrowDown":
                    handleArrowDown();
                    break;
                  case "Escape":
                    handleEscape();
                    break;
                  default:
                    break;
                }
              }}
            >
              <div
                id={`flashmsg${key}`}
                ref={flashMsgRefs[key]}
                className="d-flex flex-grow-1 text-muted align-self-center"
                onClick={() => {
                  onSelectMsg(element);
                }}
              >
                {displayMsgList(element?.short_name, regexExp)}
                <UncontrolledTooltip placement="left" target={`flashmsg${key}`}>
                  {element?.message}
                </UncontrolledTooltip>
              </div>
              <div>
                <i
                  id={`edittooltip${key}`}
                  className="mdi mdi-pencil font-size-18 pl-2 text-primary"
                  onClick={() => {
                    setObjFlashMessage({
                      id: element.id,
                      short_name: element.short_name,
                      message: element.message,
                    });
                    toggleFlashEditCreate();
                  }}
                />

                <i
                  id={`deletetooltip${key}`}
                  className="mdi mdi-window-close font-size-18 pl-2 text-danger"
                  onClick={() => {
                    setObjFlashMessage({
                      id: element.id,
                      short_name: element.short_name,
                      message: element.message,
                    });
                    toggleFlashDelete();
                  }}
                />
                <UncontrolledTooltip
                  target={`edittooltip${key}`}
                  placement="right"
                >
                  {t("Edit")}
                </UncontrolledTooltip>
                <UncontrolledTooltip
                  placement="right"
                  target={`deletetooltip${key}`}
                >
                  {t("Delete")}
                </UncontrolledTooltip>
              </div>
            </a>
          ))}
      </div>
      {/*****MODALS*****/}
      {/* FLASH MESSAGE*/}
      <FlashMsg
        isFlashEditCreate={isFlashEditCreate}
        toggleFlashEditCreate={toggleFlashEditCreate}
        isFlashDelete={isFlashDelete}
        toggleFlashDelete={toggleFlashDelete}
        objFlashMsg={objFlashMsg}
      />
    </>
  );
};

export default withTranslation()(FlashMsgList);
